import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { OnboardingChooseDeckWrapper } from '@seedlang/hoc';
import { Theme, Constants } from '@seedlang/constants';
import LearningPreferenceButton from 'components/onboarding/learning_preference_button';
import { AppUI } from '@seedlang/state';
import { DictionaryIcon, SpeakingIcon, TriviaCircleIcon, WordListIcon } from '@seedlang/icons';
import Spinner from 'components/spinner';
import OnboardingContent from 'components/onboarding/onboarding_content';
import OnboardingWrapper from 'components/onboarding/onboarding_wrapper';
import OnboardingIllustration from 'components/onboarding/onboarding_illustration';

@observer
class OnboardingChooseDeck extends React.Component {

  @computed get showWorksheets() {
    return window.location.href.split('/group/')[1] === Constants.EASY_GERMAN_GROUP_ID;
  }

  render() {
    return (
      <OnboardingWrapper>
        <OnboardingIllustration
          text='How would you like to get started?'
          reaction='disappointed'
          languageId={AppUI.targetLanguageId}
        />
        <OnboardingContent>
          {
            this.props.showSpinner &&
              <Spinner
                background='white'
              />
          }
          {
            !this.props.showSpinner &&
              <div>
                {
                  this.showWorksheets &&
                    <LearningPreferenceButton
                      isMobile={AppUI.layout.isMobile}
                      height='100px'
                      icon={<TriviaCircleIcon />}
                      onClick={() => AppUI.routeStore.routeToNamed('groups.show', {groupId: Constants.EASY_GERMAN_GROUP_ID})}
                      background={Theme.purple}
                      name='Find exercises from Easy German videos.'
                    />
                }
                <LearningPreferenceButton
                  isMobile={AppUI.layout.isMobile}
                  height='100px'
                  icon={<SpeakingIcon />}
                  onClick={() => this.props.onSelectLearningPreference('content_tree')}
                  background={Theme.orange}
                  name='Give me speaking and listening practice.'
                />
                <LearningPreferenceButton
                  isMobile={AppUI.layout.isMobile}
                  height='100px'
                  icon={<DictionaryIcon />}
                  onClick={() => this.props.onSelectLearningPreference('vocab')}
                  background={Theme.green}
                  name='Help me to increase my vocabulary.'
                />
                {
                  AppUI.targetLanguageId === 'DE' && !this.showWorksheets &&
                    <LearningPreferenceButton
                      isMobile={AppUI.layout.isMobile}
                      height='100px'
                      icon={<TriviaCircleIcon />}
                      onClick={() => this.props.onSelectLearningPreference('trivia')}
                      background={Theme.purple}
                      name="I'd like to learn while playing trivia."
                    />
                }
                {
                  AppUI.targetLanguageId !== 'DE' && !this.showWorksheets &&
                    <LearningPreferenceButton
                      isMobile={AppUI.layout.isMobile}
                      height='100px'
                      icon={<WordListIcon />}
                      onClick={() => this.props.onSelectLearningPreference('conjugation')}
                      background={Theme.purple}
                      name="I'd like to learn the conjugation of verbs."
                    />
                }
              </div>
          }
        </OnboardingContent>
      </OnboardingWrapper>
    );
  }
}

export default OnboardingChooseDeckWrapper(OnboardingChooseDeck);
